import React from 'react';

const PHASE_COLOR = { idle: '#94a3b8', ping: '#f59e0b', download: '#2563eb', upload: '#059669', done: '#059669', error: '#dc2626' };
const PHASE_LABEL = { idle: 'Ready to test', ping: 'Checking ping…', download: 'Testing download…', upload: 'Testing upload…', done: 'Test complete', error: 'Test failed' };

// Radial meter (plain CSS conic-gradient, no chart library) shared by the portal and
// technical speed test pages — fills toward `maxScale` Mbps as the live reading comes in
// during the download/upload legs, showing the phase name once there's no number to show yet.
export default function SpeedTestGauge({ phase, liveMbps, maxScale = 200, size = 190 }) {
  const color = PHASE_COLOR[phase] || PHASE_COLOR.idle;
  const value = liveMbps != null ? liveMbps : 0;
  const angle = Math.min(value / maxScale, 1) * 360;
  const inner = size - 32;
  const showNumber = phase === 'download' || phase === 'upload' || phase === 'done';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
      <div style={{
        width: size, height: size, borderRadius: '50%',
        background: `conic-gradient(${color} ${angle}deg, #eef0f5 ${angle}deg)`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'background .25s linear',
      }}>
        <div style={{
          width: inner, height: inner, borderRadius: '50%', background: 'var(--cb-ffffff)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          boxShadow: 'inset 0 0 0 1px var(--cb-eceef5)',
        }}>
          <div style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--c-111827)', lineHeight: 1 }}>
            {showNumber ? value.toFixed(1) : '—'}
          </div>
          <div style={{ fontSize: '.72rem', color: 'var(--text-muted)', marginTop: 4 }}>Mbps</div>
        </div>
      </div>
      <div style={{ fontSize: '.85rem', fontWeight: 600, color }}>{PHASE_LABEL[phase] || ''}</div>
    </div>
  );
}
